module.exports = "../images/icons/checked-box.svg";